import { createFileRoute } from '@tanstack/react-router';
import { AdminDeliveryCostPalletPage } from '@/features/admin/admin-delivery-cost-pallet-page';

export const Route = createFileRoute('/admin/delivery-cost/pallet/')({
  component: AdminDeliveryCostPalletRoute,
});

function AdminDeliveryCostPalletRoute() {
  return <AdminDeliveryCostPalletPage />;
}
